import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import api from '@/modules/api'
/* config */
import { development, production } from '@/common/config'
/* vue-i18n */
import { i18n, setupLocaleMsg } from '@/plugins/i18n'
/* plugins */
import { getEnvConfig } from '@/plugins/env'
import { errorHandler as customErrorHandler } from '@/plugins/errorHandler'
import quasarUserOptions from '@/plugins/quasar-user-options'
/* jsnlog */
import { JL } from 'jsnlog'
/* third-party modules */
import Quasar from 'quasar/src/vue-plugin.js';
import moment from 'moment'
import { createGtm } from '@gtm-support/vue-gtm'
import { use } from 'echarts/core'
import {
  BarChart,
  LineChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
  LinesChart
} from 'echarts/charts'
import {
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  ToolboxComponent,
  DataZoomComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
use([
  BarChart,
  LineChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
  LinesChart,
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  ToolboxComponent,
  DataZoomComponent
])

let app
(async () => {
  /* setup env */
  const config = process.env.NODE_ENV === 'production' ? production : development
  Object.assign(config, await getEnvConfig())
  setupLocaleMsg(config)

  /* setup jsnlog */
  const appender = JL.createAjaxAppender('cybssCrmAppender')
  appender.setOptions!({
    url: `${config.VUE_APP_HOST_BACKEND_URL}jsnlog.logger`,
  })

  const gtm = createGtm({
    id: config.GTM_ID,
    enabled: config.GTM_ENABLED,
  })

  app = createApp(App)
  /* setup config */
  app.config.errorHandler = customErrorHandler

  app.config.globalProperties.$config = config
  app.config.globalProperties.$JL = JL('CYBSS-CRM-Vue').setOptions({
    appenders: [appender],
  })
  app.config.globalProperties.$moment = moment

  /* setup vue app */
  app
    .use(i18n)
    .use(store)
    .use(router)
    .use(VueAxios, api as any)
    .use(Quasar, quasarUserOptions as any)
    .use(gtm)
  app.mount('#app')
})()
